import baseApi from './baseApi';

const prodQueueApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getProductionQueueAIReportAvailability: builder.query({
      query: restaurantUuid => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/device/api/v1/ai-production-queue-report/availability`,
        method: 'GET',
      }),
    }),
    getProductionQueueRecommendationAIReport: builder.query({
      query: ({ restaurantUuid, uuid }) => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/device/api/v1/ai-production-queue-report/${uuid}`,
        method: 'GET',
      }),
    }),
    completeProductionQueueRecommendation: builder.mutation({
      query: ({ restaurantUuid, uuid }) => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/device/api/v1/recommendations/${uuid}/complete`,
        method: 'PUT',
      }),
    }),
    resetProductionQueueRecommendation: builder.mutation({
      query: ({ restaurantUuid, uuid }) => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/device/api/v1/recommendations/${uuid}`,
        method: 'PUT',
      }),
    }),
    cancelProductionQueueRecommendation: builder.mutation({
      query: ({ restaurantUuid, uuid }) => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/device/api/v1/recommendations/${uuid}`,
        method: 'DELETE',
      }),
    }),
    updateProductionQueueRecommendationStage: builder.mutation({
      query: ({ restaurantUuid, uuid, data }) => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/device/api/v1/recommendations/${uuid}/stage`,
        method: 'PUT',
        data,
      }),
    }),
    updateProductionQueueRecommendationBatchSize: builder.mutation({
      query: ({ restaurantUuid, uuid, data }) => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/device/api/v1/recommendations/${uuid}/update-batch-size`,
        method: 'PUT',
        data,
      }),
    }),
    createProductionQueueAdhocRecommendation: builder.mutation({
      query: ({ restaurantUuid, data }) => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/device/api/v1/adhoc-recommendations`,
        method: 'POST',
        data,
      }),
    }),
    updateProductionQueueAdhocRecommendation: builder.mutation({
      query: ({ restaurantUuid, uuid, data }) => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/device/api/v1/adhoc-recommendations/${uuid}`,
        method: 'PUT',
        data,
      }),
    }),
    deleteProductionQueueAdhocRecommendation: builder.mutation({
      query: ({ restaurantUuid, uuid }) => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/device/api/v1/adhoc-recommendations/${uuid}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetProductionQueueAIReportAvailabilityQuery: useProdAIReportAvailability,
  useLazyGetProductionQueueRecommendationAIReportQuery: useLazyProdRecAIReport,
  useCompleteProductionQueueRecommendationMutation: useCompleteProdRec,
  useResetProductionQueueRecommendationMutation: useResetProdRec,
  useCancelProductionQueueRecommendationMutation: useCancelProdRec,
  useUpdateProductionQueueRecommendationStageMutation: useUpdateStage,
  useUpdateProductionQueueRecommendationBatchSizeMutation: useUpdateBatchSize,
  useCreateProductionQueueAdhocRecommendationMutation: useCreateAdhocRec,
  useUpdateProductionQueueAdhocRecommendationMutation: useUpdateAdhocRec,
  useDeleteProductionQueueAdhocRecommendationMutation: useDeleteAdhocRec,
} = prodQueueApi;

export default prodQueueApi;
